import { render } from "./FootballResultTable.vue?vue&type=template&id=6f0f01c5&scoped=true"
import script from "./FootballResultTable.vue?vue&type=script&lang=js"
export * from "./FootballResultTable.vue?vue&type=script&lang=js"

import "./FootballResultTable.vue?vue&type=style&index=0&id=6f0f01c5&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f0f01c5"]])

export default __exports__